export default {"src":"/_next/static/media/televerification.9f0d6e1f.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};